export const getEmployeeByDesignationIdUrl = (hasConract: boolean) => {
    return `/employee/designation?hasContract=${hasConract}`
}